export { default } from './TeacherImage';
